import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './transcripts.constants';
import * as types from './transcripts.types';
import * as services from './transcripts.saga-services';

function* invokeFetchSessionTranscript(action: types.IFetchSessionTranscriptAction) {
  yield call(services.fetchSessionTranscripts, action.payload.sessionId, action.payload.params);
}

function* invokeFetchSessionTranscriptSummary(action: types.IFetchSessionTranscriptSummaryAction) {
  yield call(services.fetchSessionTranscriptSummary, action.payload.sessionId);
}

export function* watchSessionTranscriptPageSaga() {
  yield takeLatest(constants.FETCH_SESSION_TRANSCRIPT, invokeFetchSessionTranscript);
  yield takeLatest(constants.FETCH_SESSION_TRANSCRIPT_SUMMARY, invokeFetchSessionTranscriptSummary);
}
